import React from 'react';
import '../css/PicuPatients.css';
import '../App.css';
import getOAuthCode from "../services/getOAuthCode";
import WriteToLog from '../services/WriteToLog';
import 'url-search-params-polyfill';

class OAuthToken extends React.Component {
  state = { patient: null, userId: null, unitname: null };
  
  async componentDidMount() {
    /* Step 1: ABC Application is launched from Epic 
    Launch URL: https://your-org-url/?iss=&launch= */
    const query = new URLSearchParams(window.location.search);
    WriteToLog("OAuthToken query parameter: " + query);
    const iss = query.get('iss');
    const launch = query.get('launch');
    WriteToLog("OAuthToken iss: " + iss);
    WriteToLog("OAuthToken launch: " + launch);

    if (iss) {
      /* Step 2: ABC Application retrieves the Conformance Statement or SMART Configuration
      Get authorize and token endpoints from smart configuration */
      //var smartConfigurationUrl = iss + '/.well-known/smart-configuration';
      let fhir_server = iss.substr(0, iss.indexOf('api'));

      try {
        let authorization_endpoint = fhir_server + 'oauth2/authorize';
        let token_endpoint = fhir_server + 'oauth2/token';

        const data = {
          iss:iss,
          launch:launch,
          oauth2_authorize_uri:authorization_endpoint,
          oauth2_token_uri:token_endpoint
        };

        /* Step 3: ABC Application requests a Authorization Code */
        await getOAuthCode(data);
        //console.log("after getOAuthCode .. should never get here.. ")

      } catch (err) {
        console.log(err);
      }
    } else {
      // Return Invalid Launch Error Page
    }
  }

  render() {
    return (
      <div>
        Getting OAuthToken<br />
      </div>
    );
  }
}

export default OAuthToken;
